/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lpName: NonNullable<unknown>, gpName: NonNullable<unknown>, dealLink: NonNullable<unknown> }} Coinvestments_Editemail_Defaulttemplate3Inputs */

const en_coinvestments_editemail_defaulttemplate3 = /** @type {(inputs: Coinvestments_Editemail_Defaulttemplate3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dear ${i?.lpName} team,

I am pleased to share details of a new co-investment opportunity now available through ${i?.gpName}.

For more information about the opportunity, please visit our deal site linked here: ${i?.dealLink}

If you have any questions or would like to discuss the opportunity with our team, please reach out directly to your ${i?.gpName} relationship lead.

Best regards,
The ${i?.gpName} team`)
};

/**
* | output |
* | --- |
* | "Dear {lpName} team, I am pleased to share details of a new co-investment opportunity now available through {gpName}. For more information about the opportuni..." |
*
* @param {Coinvestments_Editemail_Defaulttemplate3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_defaulttemplate3 = /** @type {((inputs: Coinvestments_Editemail_Defaulttemplate3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Defaulttemplate3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_defaulttemplate3(inputs)
});
export { coinvestments_editemail_defaulttemplate3 as "coInvestments_editEmail_defaultTemplate" }